import { CategoryIcon } from './CategoryIcon'
import { cn } from '@wellesley/ui'
import { Category } from '@wellesley/openapi'
import { GroupAppsLink } from '../GroupAppsLink'
import { AppsRoutes } from '@wellesley/router'

export type CategoryLabelSmallProps = {
  category: Category
  className?: string
  groupName?: string
}

export const CategoryLink = ({
  category,
  className,
  groupName,
}: CategoryLabelSmallProps) => {
  return (
    <GroupAppsLink
      to={'/g/:groupname/forum/c/:categoryName' as AppsRoutes}
      props={{ categoryName: category.name }}
      onClick={(e) => e.stopPropagation()}
      groupName={groupName}
    >
      <span
        className={cn(
          'gap-xxxs inline-flex items-center align-middle text-sm font-medium hover:underline',
          className,
        )}
      >
        <CategoryIcon category={category} className="align-middle" />
        {category.displayName}
      </span>
    </GroupAppsLink>
  )
}
